import { DatoGeograficoCementoDto } from '../../../models/dato-geografico-cemento.dto';
import { DatoGeograficoCemento } from '../../../models/dato-geografico-cemento.model';
import { DatoGeograficoCementoVm } from '../../../models/dato-geografico-cemento.vm';

function asText(value: unknown): string {
  if (typeof value === 'string') {
    return value.trim();
  }
  if (typeof value === 'number' || typeof value === 'boolean') {
    return String(value).trim();
  }
  return '';
}

function asPositiveInteger(value: unknown): number {
  const numericValue = Number(value);
  return Number.isInteger(numericValue) && numericValue > 0 ? numericValue : 0;
}

function asBoolean(value: unknown): boolean {
  if (typeof value === 'boolean') {
    return value;
  }
  if (value === 1 || value === '1') {
    return true;
  }
  if (value === 0 || value === '0') {
    return false;
  }
  return false;
}

export class DatoGeograficoCementoMapper {
  static toDomain(dto: DatoGeograficoCementoDto): DatoGeograficoCemento {
    return {
      id: asPositiveInteger(dto.id),
      codigoRegion: asText(dto.codigoRegion),
      nombreRegion: asText(dto.nombreRegion),
      codSapProvincia: asText(dto.codSapProvincia),
      nombreProvincia: asText(dto.nombreProvincia),
      codSapComuna: asText(dto.codSapComuna),
      nombreComuna: asText(dto.nombreComuna),
      zonaTransporte: asText(dto.zonaTransporte),
      activo: asBoolean(dto.activo),
    };
  }

  static toVm(dto: DatoGeograficoCementoDto): DatoGeograficoCementoVm {
    const item = DatoGeograficoCementoMapper.toDomain(dto);
    const baseKey = [
      item.codigoRegion,
      item.codSapProvincia,
      item.codSapComuna,
      item.nombreComuna,
    ].join('|');
    return {
      ...item,
      trackId: String(item.id || baseKey),
    };
  }

  static toVmList(dtos: DatoGeograficoCementoDto[]): DatoGeograficoCementoVm[] {
    return dtos.map((dto) => DatoGeograficoCementoMapper.toVm(dto));
  }
}
